import { getDaysFromPeriod } from '../../../../config/constants';

/**
 * Build query parameters based on timePeriod or customRange
 */
export const buildQueryParams = (timePeriod, customRange, isAllTime) => {
  if (isAllTime) {
    // All-time: no query params needed for stats endpoint
    return {
      queryString: '',
      requestKeySuffix: 'all-time',
    };
  }
  if (customRange && customRange.startDate && customRange.endDate) {
    const start = encodeURIComponent(
      new Date(customRange.startDate).toISOString()
    );
    const end = encodeURIComponent(new Date(customRange.endDate).toISOString());
    return {
      queryString: `start_date=${start}&end_date=${end}`,
      requestKeySuffix: `range-${customRange.startDate}-${customRange.endDate}`,
    };
  }
  const days = getDaysFromPeriod(timePeriod);
  return {
    queryString: `days=${days}`,
    requestKeySuffix: `${days}d`,
  };
};
